import { Row } from 'antd';
import Sider from 'antd/es/layout/Sider';
import { User } from '@Types/index';
import { Balance } from '@Types/api/form/leaveRequest/Balance';
import classNames from 'classnames';
import BasicInformationSection from '../components/BasicInformationSection/BasicInformationSection';
import MaterialRequestInformation from '../components/MaterialRequestInformation/MaterialRequestInformation';
import styles from './information-sidebar-desktop.module.css';

interface InformationSidebarDesktopProps {
  userInfo: User;
  selectedUser?: User;
  showMRsection?: boolean;
  showSelectEmployee?: boolean;
  showLeaveBalance?: boolean;
  showExtraUserFields?: boolean;
  balance?: Balance;
  requestHeaderStep?: boolean;
  handleSearchEmpByNumber?: (empNumber?: string) => void;
  handleApplySelectedUser?: () => void;
}

const DekstopLayout: React.FC<InformationSidebarDesktopProps> = ({
  userInfo,
  selectedUser,
  balance,
  handleSearchEmpByNumber,
  handleApplySelectedUser,
  requestHeaderStep,
  showExtraUserFields,
  showLeaveBalance,
  showMRsection,
  showSelectEmployee,
}) => {
  return (
    <Sider width={405} className={styles.siderContainer} theme="light">
      <Row
        className={classNames(
          styles.informationContainer,
          'trojan-glassphormism-box trojan-glassphormism-box-shadow'
        )}
      >
        {showMRsection ? (
          <MaterialRequestInformation requestHeaderStep={requestHeaderStep} />
        ) : (
          <BasicInformationSection
            userInfo={userInfo}
            selectedUser={selectedUser}
            showLeaveBalance={showLeaveBalance}
            balance={balance}
            showSelectEmployee={showSelectEmployee}
            handleSearchEmpByNumber={handleSearchEmpByNumber}
            handleApplySelectedUser={handleApplySelectedUser}
            showExtraFields={showExtraUserFields}
          />
        )}
      </Row>
    </Sider>
  );
};

export default DekstopLayout;
